<template>
  <v-layout row justify-center>
    <v-dialog
      transition="slide-y-transition"
      v-model="deleteDriverAutoDialog"
      max-width="570"
      persistent
      @keydown.esc="close"
    >
      <v-card class="confirm-dialog">
        <v-card-title>
          <v-layout align-center justify-space-between dialog-title>
            {{ $t('driverAutoDeleteDialog.title') }}
            <v-icon class="svg-icon ml-4" @click="close">mdi-close</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-layout align-center justify-center class="btns-wrapper mt-4 mb-4">
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isLoading"
              class="error mb-4 mr-4"
              depressed
              @click="close"
            >{{ $t('common.btns.cancel') }}</v-btn>
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isLoading"
              class="warning mb-4"
              depressed
              @click="confirmDeleteDriverAuto"
            >{{ $t('common.btns.ok') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'DeleteDriverAutoDialog',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      dialog: 'driver/getDeleteDriverAutoDialogState',
      driverDeleteAuto: 'driver/getDriverDeleteAuto',
      isLoading: 'global/getLoader',
    }),
    deleteDriverAutoDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      deleteDriverAuto: 'driver/deleteDriverAuto',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      clearAlertSuccess: 'global/clearAlertSuccess',
      setAlertSuccess: 'global/setAlertSuccess',
      setLoader: 'global/setLoader',
      setDeleteDriverAutoDialogState: 'driver/setDeleteDriverAutoDialogState',
      setDriverDeleteAuto: 'driver/setDriverDeleteAuto',
    }),
    async confirmDeleteDriverAuto() {
      this.setLoader(true);
      try {
        const message = await this.deleteDriverAuto({
          driverId: this.$route.params.driverId,
          autoId: this.driverDeleteAuto.id,
        });

        this.setAlertSuccess({ message, state: true });
        this.$vuetify.goTo(0, 'easeInOutCubic');

        setTimeout(() => {
          this.clearAlertSuccess();
        }, 3000);
        this.clearAlertError();
        this.close();
      } catch (error) {
        this.close();
      }
    },
    close() {
      this.setDeleteDriverAutoDialogState(false);
      this.setDriverDeleteAuto(null);
      this.setLoader(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
    word-break: break-word;
}
</style>
